import SVGIconWrapper from "./SVGIconWrapper"

const IconAngleRightBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 298.6 500"
        iconClass={`icon--angle-right-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M298.6 250L48.6 0 0 48.6 201.4 250 0 451.4 48.6 500l250-250" />
    </SVGIconWrapper>
)

export default IconAngleRightBold